import React, { Component } from 'react';
import Translations from "../../translations/translations.json";
import { connect } from 'react-redux';

class Footer extends Component {
    setEnglish = () => {
        this.props.dispatch({ type: "ENGLISH" });
        this.scrollToTop();
    };

    setFrench = () => {
        this.props.dispatch({ type: "FRENCH" });
        this.scrollToTop();
    };
    scrollToTop() {
        document.documentElement.scrollTop = 0;
    }

    render() {
        return (
            <div className="footer__main">
                <div className="footer__container">
                    <div className="footer__wrapper">
                        {/* <p className="footer__language"> {this.props.lang === "fr" ? <a onClick={this.setEnglish}>English</a> : <a onClick={this.setFrench}>Français</a>} </p> */}
                        <p className="footer__info">
                            <a href="https://www.facebook.com/OURidesCanada/" target="_blank" rel="noopener noreferrer" className="footer__icons"><i className="fab fa-facebook-square"></i></a>
                            <a href="https://www.instagram.com/ouridescanada/" target="_blank" rel="noopener noreferrer" className="footer__icons"><i className="fab fa-instagram"></i></a>
                            <a href="https://twitter.com/ouridescanada/" target="_blank" rel="noopener noreferrer" className="footer__icons"><i className="fab fa-twitter-square"></i></a>
                        </p>
                        <p className="footer__copyright"> © OURides 2019 - Tous droits réservés.</p>
                        <p className="footer__watermark">Créé par: <a href="https://leadhouse.ca" target="_blank">Leadhouse</a> et l'équipe de OURides</p>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.reducerLang.lang
});
export default connect(mapStateToProps)(Footer);